import {useMutation, useQuery, useQueryClient} from "react-query";
import http from "../../../Services/Network/http";
import DataTable from "react-data-table-component";
import {BsFillTrashFill} from "react-icons/bs";
import {Button} from "reactstrap";
import {useNavigate} from "react-router";

export const AdminProductCategoriesList = () => {
    const queryClient = useQueryClient();
    const navigate = useNavigate();
    const deleteProductCategoryMutation = useMutation(productCategoryId => http.remove(`/product/DeleteProductCategory/${productCategoryId}`), {
        onSuccess: () => {
            queryClient.invalidateQueries(["fetchProductCategories"]);
        },
        onError: (error) => {
            console.log(error.response.data);
        },
    });

    const { data: productCategories } = useQuery(
        "fetchProductCategories",
        () => http.get(`/Product/GetProductCategories`));

    const columns =[
        {
            name: 'Tittel',
            selector: row => row.title,
            grow: 3
        },
        {

            cell: (row) => (
                <>
                    <BsFillTrashFill cursor="Pointer" onClick={() => window.confirm("Er du sikker på at du vil slette produktkategorien?") ? deleteProductCategoryMutation.mutate(row.productCategoryId) : ""} />
                </>),
            ignoreRowClick: true,
            allowOverflow: true,
            button: true,
        }
    ];


    return (
        <div>
            <h2 style={{float:'left'}}>Admin &gt; Produktkategorier</h2>
            <Button color="primary"  style={{float:'right'}} size="sm" onClick={() => navigate("/admin/ProductCategory")}>Legg til ny kategori</Button>
            <DataTable
                highlightOnHover={true}
                onRowClicked={(row) => navigate(`/admin/ProductCategory/${row.productCategoryId}`)}
                columns={columns}
                data={(productCategories || [])}
            />


        </div>
    );
}